import { render, staticRenderFns } from "./UserSummary.vue?vue&type=template&id=1508fbca"
import script from "./UserSummary.vue?vue&type=script&lang=js"
export * from "./UserSummary.vue?vue&type=script&lang=js"
import style0 from "./UserSummary.vue?vue&type=style&index=0&id=1508fbca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports